<template>
  <div class="bg-white rounded-md inline-block relative">
    <DatePicker v-if="isLesson" ref="calendar" locale="en" v-model="date" is-required :disabled-dates="disabledDates" :attributes='attributes'/>
    <DatePicker v-else ref="calendar" locale="en" v-model="range" is-range is-required :disabled-dates="disabledDates" :attributes='attributes'/>
    <div class="p-2">
      <label v-if="isLesson">
        {{ i18n.t('calendar.start_date') }}
      </label>
      <label v-else>
        {{ i18n.t('general.from') }}
      </label>
      <div class="pb-2">
        <template v-if="fromTimeSlots.length">
          {{ getDateWZero(this.isLesson ? this.date : this.range.start) }}
          <select v-model="fromTime" class="cursor-pointer px-2 py-1 rounded"
                  :class="{'bg-jt-pink': !fromTime}"
          >
            <option :value="null">
              {{ i18n.t('calendar.select_time') }}
            </option>
            <option v-for="time in fromTimeSlots" :key="time" :value="time">
              {{ time }}
            </option>
          </select>
        </template>
        <span v-else>
          {{ i18n.t('calendar.shop_closed') }}
        </span>
      </div>
      <template v-if="!isLesson">
        <label>
          {{ i18n.t('general.to') }}
        </label>
        <div class="pb-4">
          <template v-if="toTimeSlots.length">
            {{ getDateWZero(range.end) }}
            <select v-model="toTime" class="cursor-pointer px-2 py-1 rounded"
                    :class="{' bg-jt-pink': !toTime}"
            >
              <option :value="null">
                {{ i18n.t('calendar.select_time') }}
              </option>
              <option v-for="time in toTimeSlots" :key="time" :value="time">
                {{ time }}
              </option>
            </select>
          </template>
          <span v-else>{{ i18n.t('calendar.select_time') }}</span>
        </div>
        <div v-if="fromTime && toTime && periodTooSmall" class="text-red-500 text-sm max-w-[230px]">
          {{ i18n.t('calendar.period_too_small', {hours: minimumRental}) }}
        </div>
      </template>
      <button class="jt-btn w-full" :disabled="!validPeriod" data-umami-event="Book button" @click="bookItem">
        {{ i18n.t('calendar.book') }}
      </button>
    </div>
  </div>
</template>

<script>
  import DatePicker from 'v-calendar/lib/components/date-picker.umd'

  export default {
    name : 'ItemCalendar',
    components: {
      DatePicker,
    },
    props: {
      availabilityUrl: String,
      minimumRental: Number,
      isLesson: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        date: new Date(),
        range: {
          start: new Date(),
          end: new Date()
        },
        fromTime: '',
        toTime: '',
        availability: {},
        disabledDates: [],
        attributes: [
          {
            key: 'open',
            bar: 'green',
            popover: {
              label: this.i18n.t('calendar.full_availability'),
            },
            dates: [],
          },
          {
            popover: {
              label: this.i18n.t('calendar.shop_closed'),
            },
            key: 'closed',
            bar: 'red',
            dates: [],
          },
          {
            popover: {
              label: this.i18n.t('calendar.all_booked'),
            },
            key: 'booked',
            dates: [],
          },
          {
            key: 'open',
            bar: 'yellow',
            popover: {
              label: this.i18n.t('calendar.partially_booked'),
            },
            dates: [],
          },
        ],
        nextMonth: new Date().getMonth() + 1,
        nextYear: new Date().getFullYear()
      };
    },
    computed: {
      fromTimeSlots() {
        let fromDate = this.getDate(this.isLesson ? this.date : this.range.start);
        if (!this.availability[fromDate]) return []
        let slots = Object.keys(this.availability[fromDate])
                          .filter((x) => this.availability[fromDate][x] == 'available')

        if (!this.isLesson &&this.getDate(this.range.start) == this.getDate(this.range.end) && this.toTime) {
          slots = slots.filter((x) => x.split(':').join() < this.toTime.split(':').join())
        }
        return slots;
      },
      toTimeSlots() {
        let toDate = this.getDate(this.range.end);
        if (!this.availability[toDate]) return []
        let slots = Object.keys(this.availability[toDate])
                          .filter((x) => this.availability[toDate][x] == 'available')

        if (this.getDate(this.range.start) == this.getDate(this.range.end) && this.fromTime) {
          slots = slots.filter((x) => x.split(':').join() > this.fromTime.split(':').join())
        }
        return slots;
      },
      bookPeriod() {
        if (this.isLesson) {
          return {
            from: `${this.getDate(this.date)} ${this.fromTime}:00`
          }
        }

        return {
          from: `${this.getDate(this.range.start)} ${this.fromTime}:00`,
          to: `${this.getDate(this.range.end)} ${this.toTime}:00`,
        }
      },
      periodTooSmall() {
        const from_d = new Date(this.bookPeriod.from);
        const to_d = new Date(this.bookPeriod.to);
        return this.diff_hours(from_d, to_d) < this.minimumRental
      },
      validPeriod() {
        const from_d = new Date(this.bookPeriod.from);
        const to_d = new Date(this.bookPeriod.to);
        return this.fromTime && (
          (this.toTime && !this.periodTooSmall)
          || this.isLesson
        )
      }
    },
    watch: {
      range() {
        this.fromTime = null;
        this.toTime = null;
      },
      date() {
        this.fromTime = null;
      },
    },
    mounted() {
      this.loadNextMonth(true);
      $('.vc-arrow.is-right').on('click', () => {
        this.loadNextMonth();
      })
    },
    methods: {
      getAvailability(month, year, set_date = false) {
        fetch(this.availabilityUrl + '?month=' + month + '&year=' + year)
          .then(response => response.json())
          .then(data => {
            this.availability = Object.assign({}, this.availability, data);
            this.updateDisabledDates();
            if (set_date) {
              let first_available = Object.keys(this.availability).filter((x) => {
                return this.availability[x] != 'closed' &&
                       this.availability[x] != 'booked' &&
                       this.beginOfDay(new Date(x)) >= this.beginOfDay(new Date())
              })[0];
              if (first_available) {
                let available_times = Object.keys(this.availability[first_available]).filter( (x) => this.availability[first_available][x] == 'available' );
                this.range = {
                  start: new Date(first_available),
                  end: new Date(first_available)
                }
                this.date = new Date(first_available);
                this.fromTime = null;
                this.toTime = null;
              } else {
                this.range = {
                  start: new Date(),
                  end: new Date()
                }
                this.date = new Date();
              }
            }
          })
      },
      updateDisabledDates() {
        let yesterday = new Date().setDate(new Date().getDate() - 1);
        let disabled = [{
          start: null,
          end: yesterday
        }]
        let attrs = this.attributes
        let openDays = [];
        let closeDays = [];
        let partiallyAvailability = [];

        for (let date in this.availability) {
          if (new Date(date) <= yesterday) continue;

          if (this.availability[date] == 'booked') {
            disabled.push(new Date(date))

          } else {
            if (this.availability[date] == 'closed') {
              closeDays.push(date);
            } else if (Object.values(this.availability[date]).filter((x) => x == 'booked').length > 0) {
              partiallyAvailability.push(date);
            } else {
              openDays.push(date);
            }
          }
        }

        this.disabledDates = disabled;
        attrs[0].dates = openDays;
        attrs[1].dates = closeDays;
        attrs[2].dates = disabled
        attrs[3].dates = partiallyAvailability;
        this.attributes = attrs;
      },
      loadNextMonth(set_date = false) {
        this.getAvailability(this.nextMonth, this.nextYear, set_date);
        this.nextMonth = this.nextMonth + 1;
        if (this.nextMonth > 12) {
          this.nextMonth = 1;
          this.nextYear = this.nextYear + 1;
        }
      },
      beginOfDay(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      },
      setDayTime(date, hour_minutes) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour_minutes.split(':')[0], hour_minutes.split(':')[1]);
      },
      getDate(date) {
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      },
      getDateWZero(date) {
        return `${date.getFullYear()}/${this.addZero(date.getMonth() + 1)}/${this.addZero(date.getDate())}`;
      },
      addZero(s) {
        return (s < 10) ? '0' + s : s;
      },
      bookItem() {
        this.$emit('book:item', this.bookPeriod);
      },
      diff_hours(dt2, dt1) {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60);
        return Math.abs(Math.round(diff));
      }
    }
  }
</script>
